import { setBottomSheetIsOpen, useAppDispatch } from '@libs/store';
import { useCallback } from 'react';

export const useIsOpenBS = () => {
    const dispatch = useAppDispatch();

    return {
        setBottomSheetIsOpen: useCallback(
            (bsInternalId: string, isOpen: boolean) => {
                dispatch(setBottomSheetIsOpen({ bsInternalId, isOpen }));
            },
            [dispatch],
        ),
    };
};
